import * as Yup from "yup";

import { requiredString } from "validation";

export const editSubcategoriesValidationSchema = Yup.object().shape({
  name: requiredString,
  tokens: requiredString,
});
